module.exports = __webpack_public_path__ + "assets/img/img200.65aee6e4.png";